import React from "react";
import { ChevronRight } from "lucide-react";
import { total, usd, type ExecutiveTransaction } from "../../data/executiveOverview";

const actions = [
  {
    icon: "warning",
    title: "APAC Freight concentration risk",
    badge: { text: "Critical", className: "trend-badge trend-badge--critical" },
    impact: "$48M exposure",
    savings: "$3.1M",
  },
  {
    icon: "warning",
    title: "SaaS contract renewals — Q1 FY26",
    badge: { text: "High", className: "trend-badge trend-badge--high" },
    impact: "$94M renewals",
    savings: "$6.8M",
  },
  {
    icon: "warning",
    title: "Top-10 strategic supplier review",
    badge: { text: "High", className: "trend-badge trend-badge--high" },
    impact: "31% of spend",
    savings: "$2.8M",
  },
  {
    icon: "warning",
    title: "Tail spend rationalization — MRO",
    badge: { text: "Medium", className: "trend-badge trend-badge--medium" },
    impact: "1214 suppliers",
    savings: "$2.8M",
  },
];

export function PriorityActions({ rows }: { rows?: ExecutiveTransaction[] }) {
  const maverick = rows?.filter((row) => row.Maverick_Spend_Flag === "Yes") || [];
  const offContract = rows?.filter((row) => row.Contract_Status !== "Contracted") || [];
  const tail = rows?.filter((row) => row.Tail_Spend_Flag === "Yes") || [];
  const review = rows?.filter((row) => row.Classification_Status !== "Classified") || [];
  const activeActions = rows ? [
    { title: "Review maverick spend", impact: `${usd(total(maverick, "Spend_Amount_USD"))} exposure`, savings: usd(total(maverick, "Savings_Identified_USD")), badge: { text: "Critical", className: "trend-badge--critical" } },
    { title: "Resolve non-contracted purchases", impact: `${usd(total(offContract, "Spend_Amount_USD"))} exposure`, savings: usd(total(offContract, "Savings_Identified_USD")), badge: { text: "High", className: "trend-badge--high" } },
    { title: "Review low-confidence classifications", impact: `${review.length} transactions`, savings: usd(total(review, "Savings_Identified_USD")), badge: { text: "High", className: "trend-badge--high" } },
    { title: "Rationalize tail spend", impact: `${new Set(tail.map((row) => row.Supplier_ID)).size} suppliers`, savings: usd(total(tail, "Savings_Identified_USD")), badge: { text: "Medium", className: "trend-badge--medium" } },
  ].filter((_, index) => [maverick, offContract, review, tail][index].length > 0) : actions;
  return (
    <div className="priority-panel">
      <div className="trend-panel__title">Executive Priority Panel</div>
      <div className="trend-panel__desc">{rows ? "Transaction signals for procurement review." : "AI-generated – where leadership should focus now."}</div>
      <div className="trend-panel__divider" />
      <div className="priority-panel__list">
        {activeActions.map((item, idx) => (
          <div className="priority-panel__item" key={idx}>
            <div className="priority-panel__item-row1" style={{ display: 'flex', alignItems: 'center' }}>
              {/* Col-1: Warning Icon */}
              <span className="priority-panel__icon" aria-hidden="true">
                <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M17.29 13.3456L10.6234 1.6789C10.478 1.4224 10.2672 1.20905 10.0125 1.06062C9.75774 0.91219 9.46819 0.833984 9.17337 0.833984C8.87855 0.833984 8.589 0.91219 8.33427 1.06062C8.07953 1.20905 7.86873 1.4224 7.72337 1.6789L1.0567 13.3456C0.909773 13.6 0.832727 13.8888 0.833378 14.1827C0.834029 14.4765 0.912352 14.7649 1.06041 15.0188C1.20847 15.2726 1.42099 15.4827 1.67645 15.6279C1.93191 15.7731 2.22121 15.8482 2.51504 15.8456H15.8484C16.1408 15.8453 16.428 15.768 16.6811 15.6216C16.9342 15.4752 17.1444 15.2648 17.2905 15.0115C17.4365 14.7582 17.5134 14.4709 17.5133 14.1785C17.5133 13.8861 17.4362 13.5988 17.29 13.3456Z" stroke="#492750" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M9.18176 5.8457V9.17904" stroke="#492750" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M9.18176 12.5117H9.1901" stroke="#492750" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </span>
              {/* Col-2: Title, Impact/Savings */}
              <div style={{ flex: 1, minWidth: 0 }}>
                <div className="priority-panel__item-title" style={{ fontWeight: 400, fontSize: 14, color: '#0A0A0A', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <span>{item.title}</span>
                  <span className={"trend-badge " + item.badge.className} style={{ marginLeft: 12 }}>{item.badge.text}</span>
                </div>
                <div className="priority-panel__item-row2" style={{ fontSize: 13, color: '#222', margin: 0 }}>
                  Impact: <b>{item.impact}</b> &nbsp; Savings: <b>{item.savings}</b>
                </div>
              </div>
              {/* Col-3: Badge and Angle Right Icon */}
              <ChevronRight size={18} color="#B0B0B0" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
